import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import TableHeader from 'modules/_shared/Table/components/TableHeader';
import { ColumnCell } from 'modules/_shared/Table/types/ColumnCell';

import { useNotesSection } from '../context/NotesSectionContext';

const NotesSectionTableHeader: FC = () => {
  const { t } = useTranslate();

  const { data } = useNotesSection();

  const hasOptions = data.isAdmin && !data.isReadOnly;

  const columns = [
    { key: 'date', content: t('Date') },

    { key: 'Note', content: t('Note') },

    hasOptions ? { key: 'actions', content: '', textPosition: 'center' } : null,
  ].filter(Boolean) as ColumnCell[];

  return <TableHeader columns={columns} />;
};

export default NotesSectionTableHeader;
